<template>
  <div id="serials">
    <my-header></my-header>
    <div class="pd20">
      <ul class="breadcrumb">
        <li>
          <router-link :to="{ name: 'ManageTracking'}">{{'Manage tracking'|translate}}</router-link>
        </li>
        <li>{{'Manage serials'|translate}}</li>
      </ul>
      <ul class="nav nav-tabs second-tab" id="myTabs" role="tablist">
        <li role="presentation" v-bind:class="{ active: select_tab == 'manage_serial' }">
          <a href="#" v-on:click="select_tab = 'manage_serial'">{{'List'|translate}}</a>
        </li>
        <li role="presentation" v-bind:class="{ active: select_tab == 'manage_print' }">
          <a href="#" v-on:click="select_tab = 'manage_print'">{{'Export'|translate}}</a>
        </li>
      </ul>
      <div class="tab-content no-border">
        <div
          class="tab-pane fade"
          v-bind:class="{ active: select_tab == 'manage_serial', in: select_tab == 'manage_serial' }"
        >
          <a class="btn btn-primary" v-on:click="showModal(null)">{{'Generate stamps'|translate}}</a>
          <div class="pull-right">
            <form class="form-inline search-stamp" v-on:submit.prevent="search">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="s.from_serial"
                  :placeholder="'From serial'|translate"
                />
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="s.to_serial"
                  :placeholder="'To serial'|translate"
                />
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="s.code"
                  :placeholder="'Code'|translate"
                />
              </div>
              <button type="submit" class="btn btn-default">{{'Search'|translate}}</button>
            </form>
            <!--  -->
          </div>
          <p class="mt20">
            {{'Available'|translate}} :
            <strong>{{total_available}}</strong>
            &nbsp;&nbsp;/
            {{'Total'|translate}} :
            <strong>{{total_record}}</strong>
          </p>
          <p
            class="mt10"
            v-if="list_items && list_items.length == 0"
          >{{'There is no data'|translate}}</p>
          <table class="table mt10" v-if="list_items && list_items.length > 0">
            <thead>
              <tr>
                <th>{{'Serial'|translate}}</th>
                <th>{{'Code'|translate}}</th>
                <th>{{'Purchase ID'|translate}}</th>
                <th>{{'Harvest ID'|translate}}</th>
                <th>{{'Harvest Date'|translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item) in list_items" :key="item.id">
                <td>
                  <router-link
                    v-if="item.harvest_id || item.purchase_id "
                    :to="{ name: 'SearchCode', params: { unique_code: item.unique_code }}"
                  >{{ item.seri_number }}</router-link>
                  <span v-if="!item.harvest_id && !item.purchase_id">{{ item.seri_number }}</span>
                </td>
                <td>{{ item.unique_code }}</td>
                <td>
                                    <router-link
                    
                    :to="{ name: 'PurchaseDetail', params: { id: item.purchase_id }}"
                  >{{ item.purchase_id }}</router-link>
                  
                <td>
                  <router-link
                    :to="{ name: 'ViewHarvest', params: { season_id: item.season_id, harvest_id: item.harvest_id }}"
                  >{{item.harvest_id}}</router-link>
                  
                  
                </td>
                <td>
                  <span v-if="item.start_time">{{ item.start_date | moment("DD/MM/YYYY") }}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <paginate
            v-if="total_page > 1"
            :page-count="total_page"
            :click-handler="clickPage"
            :prev-text="'Prev'|translate"
            :next-text="'Next'|translate"
            v-model="page"
            :container-class="'pagination'"
          ></paginate>
          <form-serial v-if="show_form" ref="form" @modalData="modalData"></form-serial>
        </div>
        <div
          class="tab-pane fade"
          v-bind:class="{ active: select_tab == 'manage_print', in: select_tab == 'manage_print' }"
        >
          <form v-on:submit.prevent="submitSearchPrint">
            <div class="row">
              <div class="col-md-6">
                <label>{{'From serial'|translate}}</label>
                <input
                  type="number"
                  v-model="from_serial"
                  required
                  ref="from_serial"
                  :placeholder="'From serial'|translate"
                  class="form-control"
                />
              </div>
              <div class="col-md-6">
                <label>{{'To serial'|translate}}</label>
                <input
                  type="number"
                  v-model="to_serial"
                  required
                  ref="to_serial"
                  :placeholder="'To serial'|translate"
                  class="form-control"
                />
              </div>
            </div>
            <p class="mt10">
              {{'Min'|translate}}:
              <strong>1</strong>
              , &nbsp;
              {{'Max'|translate}}:
              <strong>{{total_record}}</strong>
              , &nbsp;
              {{'Max item per print'|translate}}:
              <strong>{{2000}}</strong>
            </p>
            <button class="btn btn-info mt20" type="submit" :disabled="working_search">
              <i v-if="working_search" class="fas fa-spinner fa-spin"></i>
              {{'Search'|translate}}
            </button>
            <a
              class="btn btn-success mt20"
              v-on:click="doExport"
              v-if="print_items"
            >{{'Export to CSV'|translate}}</a>
          </form>
          <div v-if="print_items" id="list-prints">
            <p class="mt10">{{'Found'|translate}} {{print_items.length}} {{'results'|translate}}</p>
            <!-- <div class="print-item" v-for="(item) in print_items" :key="item.seri_number">
            <img class="wrapper" :src="link_svg" alt="Kiwi standing on oval" />
            <p class="seri">{{item.seri_number}}</p>
            <div class="content">
              <qrcode :value="item.link" tag="img" :options="{ width: 100 }"></qrcode>
            </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import FormSerial from "@/components/Cultivation/FormSerial";
import Paginate from "vuejs-paginate";
import MyHeader from "@/components/Layout/Header";
// import QrcodeVue from 'qrcode.vue';

export default {
  name: "ManageSerial",
  components: {
    FormSerial,
    Paginate,
    MyHeader
  },
  data() {
    return {
      show_form: false,
      list_items: null,
      page: 1,
      offset: 0,
      s: {
        from_serial: "",
        to_serial: "",
        code: ""
      },
      limit: 20,
      total_record: null,
      total_page: 1,
      total_available: null,
      block_id: null,
      block: null,
      select_tab: "manage_serial",
      from_serial: null,
      to_serial: null,
      working_search: false,
      print_items: null,
      d: null,
      cssText: `
            .print-item {
            width: 73px;
            height: 73px;
            display: inline-block;
            margin: 6px;
            position: relative;
            }

            .print-item .wrapper {
            max-width: 100%;
            position: absolute;
            }

            .print-item .seri {
            position: absolute;
            font-family: sans-serif;
            font-size: 9px;
            top: 14px;
            width: 100%;
            text-align: center;
            z-index: 4;
            margin: 0px;
            color: brown;
            }

            .print-item .content {
            padding: 19px;
            position: absolute;
            z-index: 2;
            top: 3px;
            }

            .print-item .content img {
            max-width: 100%;
            }

            @media all {
            .page-break {
                display: none;
            }
            }
            @media print {
            .page-break {
                display: block;
                page-break-before: always;
            }
            }

            `
    };
  },
  methods: {
    modalData(data) {
      this.list();
      this.getAvailable();
    },
    showModal() {
      this.show_form = true;

      setTimeout(() => {
        this.$refs.form.open();
      });
    },
    list() {
      let data = {
        offset: this.offset,
        limit: this.limit,
        code: this.s.code
      };
      if (this.s.from_serial.trim()) {
        data.from_serial = this.s.from_serial.trim();
      }
      if (this.s.to_serial.trim()) {
        data.to_serial = this.s.to_serial.trim();
      }
      Utils.request(this, true)
        .get(`/manageSerial/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          let data = response.data;
          if (data.status === "ok") {
            let list = data.data.list;
            list = list.map(item => {
              // let temp = new Date(parseInt(item.add_time) * 1000)
              // item.add_date = this.$moment(temp)

              // let temp1 = new Date(parseInt(item.start_time) * 1000)
              // item.start_date = this.$moment(temp1)
              item.link = this.prefix_link + `${item.unique_code}`;
              item.seri_number = Utils.serialFormat(item.seri_number);

              if (item.start_time) {
                let temp1 = new Date(parseInt(item.start_time) * 1000);
                item.start_date = this.$moment(temp1);
              }

              return item;
            });
            this.list_items = list;
            this.total_record = data.data.total;
            this.total_page = Utils.getTotalPages(data.data.total, this.limit);
            // update local storage
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    clickPage(pageNum) {
      this.offset = Utils.getNextOffset(pageNum, this.limit);
      this.list();
    },
    search() {
      console.log("code", this.s.code);
      if (this.s.from_serial.trim() != "" && this.s.to_serial.trim() == "") {
        return Utils.showError(
          this,
          this.$t("You must input both information: from serial and to serial")
        );
      }
      if (this.s.from_serial.trim() != "") {
        let from = parseInt(this.s.from_serial);
        let to = parseInt(this.s.to_serial);
        if (from <= 0) {
          return Utils.showError(
            this,
            this.$t("From serial must greater than 0")
          );
        }

        if (from > to) {
          return Utils.showError(
            this,
            this.$t("To serial can not smaller than from serial")
          );
        }
      }
      this.offset = 0;
      this.list();
    },
    getAvailable() {
      Utils.request(this, true)
        .get(`/manageSerial/?get_count_available=1`)
        .then(response => {
          this.total_available = response.data.data;
        });
    },
    submitSearchPrint() {
      if (this.from_serial <= 0) {
        return Utils.showError(
          this,
          this.$t("From serial must greater than 0")
        );
      }
      this.from_serial = parseInt(this.from_serial);
      this.to_serial = parseInt(this.to_serial);
      if (this.to_serial < this.from_serial) {
        return Utils.showError(
          this,
          this.$t("To serial can not smaller than from serial")
        );
      }
      if (this.to_serial - this.from_serial > 5000) {
        return Utils.showError(this, "You can not search over 5000 items");
      }
      this.working_search = true;
      this.print_items = null;
      let data = {
        from_serial: this.from_serial,
        to_serial: this.to_serial
      };
      Utils.request(this, true)
        .get(`/manageSerial/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          this.working_search = false;
          let temp = response.data.data;

          temp = temp.map(item => {
            item.seri_number = Utils.serialFormat(item.seri_number);
            item.link = this.prefix_link + `${item.unique_code}`;
            return item;
          });
          this.print_items = temp;
        });
    },
    doExport() {
      let rows = [["Stt", "Serial", "Qr code"]];
      let seq = 1;
      this.print_items.forEach(item => {
        rows.push([seq, '"' + item.seri_number + '"', item.link]);
        seq++;
      });

      let csvContent =
        "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "my_data.csv");
      document.body.appendChild(link); // Required for FF

      link.click(); // This will download the data file named "my_data.csv".
    },
    doPrint() {
      console.log("this.d", this.d);
      this.d.print(this.$el.querySelector("#list-prints"), [this.cssText]);
    }
  },
  mounted() {
    this.list();
    this.getAvailable();
    const { Printd } = window.printd;

    this.d = new Printd();

    const { contentWindow } = this.d.getIFrame();

    contentWindow.addEventListener("beforeprint", () =>
      console.log("before print event!")
    );
    contentWindow.addEventListener("afterprint", () =>
      console.log("after print event!")
    );

    let hostname = location.hostname;
    if (hostname == "farmlocal.com" || hostname == "localhost") {
      hostname = "f2f.com.vn";
    }
    this.link_svg = `static/images/stamp-${hostname}.svg`;

    let protocol = location.protocol + "//";
    this.prefix_link = protocol + location.hostname + "/s/";
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Cultivation/ManageSerial.vue